import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';
import mappers from './supplier-payment-service-mappers';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}accounting/supplier-payments`,
  [],
  [authentication],
  [],
  false,
  120000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getFilterData() {
    return conduit.get('filters');
  },

  /**
   * @returns {AxiosPromise}
   */
  getPaidSupplierPayments(dates, filters) {
    return conduit.post(
      'paid',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  downloadPaidSupplierPayments(dates, filters) {
    return conduit.post(
      'paid/download',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @param dates
   * @param filters
   * @param supplier
   * @returns {AxiosPromise}
   */
  downloadPaidSupplierPaymentSpecifications(dates, filters, supplier) {
    return conduit.post(
      'paid/specification/download',
      mappers.buildSpecificationRequest(dates, filters, supplier),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  getDueSupplierPayments(dates, filters) {
    return conduit.post(
      'due',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  downloadDueSupplierPayments(dates, filters) {
    return conduit.post(
      'due/download',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @param dates
   * @param filters
   * @param supplier
   * @returns {AxiosPromise}
   */
  downloadDueSupplierPaymentSpecifications(dates, filters, supplier) {
    return conduit.post(
      'due/specification/download',
      mappers.buildSpecificationRequest(dates, filters, supplier),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  getSupplierPayments(dates, filters) {
    return conduit.post(
      'payments',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  downloadSupplierPayments(dates, filters) {
    return conduit.post(
      'payments/download',
      mappers.buildSupplierPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  downloadSupplierPaymentSpecifications(dates, filters, payment) {
    return conduit.post(
      'payments/specification/download',
      mappers.buildSpecificationOfPaymentRequestBody(dates, filters, payment),
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/payment-service/supplier-payment-service.js